module.exports = __webpack_public_path__ + "img/20_dice[17].bc033d64.png";